module.exports = __webpack_public_path__ + "static/media/Ginny Weasley 3.0449b4f0.jpg";